import { useEffect, useRef } from "react";
import { yodaStakeholderActions } from "../logic/actions";
import { useDispatch, useSelector } from "react-redux";
import { usePrevious } from "@react-hookz/web";
import useVersionCheck from "../hooks/useVersionCheck";
import VersionUpdateModal from "./VersionUpdateModal";
import useUserSessionAnalytics from "../hooks/analytics/useUserSessionAnalytics";

//utility component that hosts global service calls
const GlobalServices = () => {
  const dispatch = useDispatch();

  const { activeNavButton } = useSelector((state) => state.system);

  // Version Check Hook
  const { isNewVersionAvailable, currentVersion, newVersion, updateVersion } =
    useVersionCheck();

  useUserSessionAnalytics();

  useEffect(() => {
    dispatch(yodaStakeholderActions.getMe());
  }, []);

  const preActiveNavButton = usePrevious(activeNavButton);

  useEffect(() => {
    if (preActiveNavButton === "info" && activeNavButton !== "info")
      dispatch(yodaStakeholderActions.resetOrderHistory());
  }, [activeNavButton, preActiveNavButton]);

  const CHECK_ORDER_HISTORY_DELAY_MS = 60000; // 1 min

  useEffect(() => {
    dispatch(yodaStakeholderActions.getOrderHistoryNewCount());
    const interval = setInterval(() => {
      dispatch(yodaStakeholderActions.getOrderHistoryNewCount());
    }, CHECK_ORDER_HISTORY_DELAY_MS);

    return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
  }, []);

  return (
    <VersionUpdateModal
      isOpen={isNewVersionAvailable}
      currentVersion={currentVersion}
      newVersion={newVersion}
      onUpdate={updateVersion}
    />
  );
};

export default GlobalServices;
